export default __webpack_public_path__ + "static/media/donut@3x.5f3a8a0d.png";